import { Button } from 'components/common/button/Button';

interface MeetingData {
    meetingName: string;
    hostName: string;
    date: string;
    time: string;
    location: string;
    participants: number;
}

interface InvitationResultContentProps {
    meetingData: MeetingData;
    onGoToMeeting: () => void;
    onGoToHome: () => void;
    onGoToLocation: () => void;
}

export const InvitationResultContent = ({
    meetingData,
    onGoToMeeting,
    onGoToHome,
    onGoToLocation
}: InvitationResultContentProps) => {
    return (
        <>
            {/* Success Animation */}
            <div className="success-animation">
                <div className="success-circle">
                    <div className="checkmark">✓</div>
                </div>
            </div>

            {/* Title Section */}
            <div className="result-title-section">
                <h1 className="result-title">모임 참여가 완료되었어요!</h1>
                <p className="result-subtitle">
                    이제 모임 장소와 시간을 확인하고<br />
                    다른 참여자들과 소통할 수 있어요
                </p>
            </div>

            {/* Meeting Summary Card */}
            <div className="meeting-summary-card">
                <div className="summary-header">
                    <h2 className="summary-title">{meetingData.meetingName}</h2>
                    <span className="summary-badge">참여 중</span>
                </div>

                <div className="summary-details">
                    <div className="summary-item">
                        <div className="summary-icon">👤</div>
                        <div className="summary-info">
                            <div className="summary-label">주최자</div>
                            <div className="summary-value">{meetingData.hostName}</div>
                        </div>
                    </div>

                    <div className="summary-item">
                        <div className="summary-icon">📅</div>
                        <div className="summary-info">
                            <div className="summary-label">날짜</div>
                            <div className="summary-value">{meetingData.date}</div>
                        </div>
                    </div>

                    <div className="summary-item">
                        <div className="summary-icon">⏰</div>
                        <div className="summary-info">
                            <div className="summary-label">시간</div>
                            <div className="summary-value">{meetingData.time}</div>
                        </div>
                    </div>

                    <div className="summary-item">
                        <div className="summary-icon">📍</div>
                        <div className="summary-info">
                            <div className="summary-label">장소</div>
                            <div className="summary-value">{meetingData.location}</div>
                        </div>
                    </div>
                </div>

                <div className="summary-participants">
                    <span className="participants-icon">👥</span>
                    <span className="participants-text">
                        현재 {meetingData.participants}명이 참여 중이에요
                    </span>
                </div>
            </div>

            {/* Quick Actions */}
            <div className="quick-actions">
                <div className="quick-action-card" onClick={onGoToMeeting}>
                    <div className="action-icon">📋</div>
                    <div className="action-text">
                        <div className="action-title">모임 상세 보기</div>
                        <div className="action-description">참여자와 정보 확인</div>
                    </div>
                    <div className="action-arrow">›</div>
                </div>

                <div className="quick-action-card" onClick={onGoToLocation}>
                    <div className="action-icon">📍</div>
                    <div className="action-text">
                        <div className="action-title">실시간 위치</div>
                        <div className="action-description">참여자 위치 공유</div>
                    </div>
                    <div className="action-arrow">›</div>
                </div>
            </div>

            {/* Info Notice */}
            <div className="result-notice">
                <div className="notice-icon">💡</div>
                <div className="notice-text">
                    모임 시작 1시간 전에 알림을 보내드릴게요
                </div>
            </div>
        </>
    );
};
